/** The stable `meta.code` of a refused `mergeChat`; the value is the wire code, so key and value match. */
export enum MergeRefusalCodeEnum {
  MERGE_SELF = 'MERGE_SELF',
  MERGE_SOURCE_ALREADY_MERGED = 'MERGE_SOURCE_ALREADY_MERGED',
  MERGE_TARGET_ALREADY_MERGED = 'MERGE_TARGET_ALREADY_MERGED',
  MERGE_TARGET_CANCELLED = 'MERGE_TARGET_CANCELLED',
  MERGE_CROSS_COMPANY = 'MERGE_CROSS_COMPANY',
  MERGE_CROSS_CUSTOMER = 'MERGE_CROSS_CUSTOMER',
}
